<template>
  <div class="container">
    <div v-if="loading" class="loading">
      <van-loading size="24px" color="#1989fa" vertical>加载中...</van-loading>
    </div>
    <div v-else class="video-list">
      <div
        class="item"
        v-for="item in videoList"
        :key="item.id"
        @click="preview(item)"
      >
        <div class="preview">
          <van-image height="300" fit="contain" :src="item.img_url" />
          <van-icon class="icon" name="play-circle-o" size="40" />
        </div>
        <div class="name">{{ item.video_name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { vList } from "@/api/video";
export default {
  name: "VideoIndex",
  data() {
    return {
      loading: true,
      videoList: [],
    };
  },
  mounted() {
    const params = this.$route.params;
    this.pId = params.pId;
    document.title = params.title;
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      console.log("pId:", this.pId);
      vList({
        pId: this.pId,
      })
        .then((res) => {
          if (res.code) {
            this.videoList = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    preview(item) {
      this.$router.push({
        name: "videoPreview",
        params: {
          title: item.video_name,
          source: item.play_url,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  .loading {
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .video-list {
    height: 100vh;
    padding-top: 16px;

    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #fff;
      padding: 12px;
      border-radius: 10px;
      margin: 0 12px 16px 12px;

      .preview {
        height: 300px;
        background-color: #000;
        position: relative;

        .icon {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: white;
        }
      }
      .name {
        font-size: 15px;
        color: #333;
        font-weight: bold;
        margin-top: 12px;
      }
    }
  }
}
</style>